import React, { Component } from 'react';
import styles from './Impact.module.css';
import { Link } from 'react-router-dom';

import logo from '../../images/CVE_logo_shadow.svg';
import impactImg from '../../images/impact.jpg';

import accordionImg1 from '../../images/catfish-in-water.png';
import accordionImg2 from '../../images/baleine-big.png';
import accordionImg3 from '../../images/baleine2-big.png';

import Menu from '../../containers/Menu/Menu';
import IntroSection from '../../components/IntroSection/IntroSection';
import AccordionList from '../../components/AccordionList/AccordionList';


export default class Impact extends Component {
  render() {
    let accordionContent = [
      {
        heading: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
        description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet",
        image: accordionImg1,
        height: '200px'
      },
      {
        heading: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
        description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet",
        image: accordionImg2,
        height: '200px'
      },
      {
        heading: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod",
        description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet",
        image: accordionImg3,
        height: '200px'
      },
    ]

    return (
      <div className={styles.Impact}>
        <Menu strokeColor="#000" />
        <div className={styles.nav}>
          <div className={styles.left}>
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className={styles.right}>
            {/* <div>
              {
                [...Array(4)].map((_, index) => {
                  if (index === (indicator - 1)) {
                    return <div key={index} style={{ width: '15px', transition: 'width 0.1s ease-out' }} />
                  } else {
                    return <div key={index} />
                  }
                })
              }
            </div> */}
          </div>
        </div>
        <IntroSection heading="Our positive impact" textImg={impactImg} fontSize="80px" description="CVE Farms delivers significant positive human, social and environmental impact" />
        <section className={styles.accordion}>
          <AccordionList content={accordionContent} />
        </section>
      </div>
    )
  }
}
